import { render, staticRenderFns } from "./ScreenDoppler.vue?vue&type=template&id=ebd5f9a4&scoped=true&"
import script from "./ScreenDoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenDoppler.vue?vue&type=script&lang=js&"
import style0 from "./ScreenDoppler.vue?vue&type=style&index=0&id=ebd5f9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd5f9a4",
  null
  
)

export default component.exports